// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yjdq","newExpiryDate":"styles_newExpiryDate__1VxAh","footer":"styles_footer__3n5lL"};